
import { defineComponent } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";
import { code5 } from "./data";

export default defineComponent({
  name: "centered-text",
  components: {
    CodeHighlighter
  },
  setup() {
    return {
      code5
    };
  }
});
